import oil_oilList from "../home";
import oil_orderList from "../order/index";
import oil_orderDetail from "../order/detail";
import oil_adminOrderList from "../salesman/index";
import oil_adminOrderDetail from "../salesman/order";

export const routerList = {
  oil_oilList: {
    name: oil_oilList.name,
    paramName: ""
  },
  oil_orderList: {
    name: oil_orderList.name,
    paramName: ""
  },
  oil_orderDetail: {
    name: oil_orderDetail.name,
    paramName: "id"
  }
};

export const adminRouterList = {
  oil_orderList: {
    name: oil_adminOrderList.name,
    paramName: ""
  },
  oil_orderDetail: {
    name: oil_adminOrderDetail.name,
    paramName: "id"
  }
};

export function jump(router, name, id) {
  const params1 = {};
  const xx = routerList[name];
  let pName = xx.paramName;
  params1[pName] = id;
  if (pName) {
    router.push({ name: xx.name, params: params1 });
  } else {
    router.push({ name: xx.name });
  }
}

export function adminJump(router, name, id) {
  const params1 = {};
  const xx = adminRouterList[name];
  let pName = xx.paramName;
  params1[pName] = id;
  if (pName) {
    router.push({ name: xx.name, params: params1 });
  } else {
    router.push({ name: xx.name });
  }
}
